// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName___32x_","productName":"Table_productName___JX0d"};